import React, { useState, useEffect, useCallback, useRef } from "react";
import { Modal, Nav } from "react-bootstrap";
import { faPencilAlt, faXmark } from "@fortawesome/free-solid-svg-icons";
import middleware from "../../Api/Middleware";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "../Customer.css";
import InputComponent from "./InputComponent";
import { useNavigate } from "react-router";
import ToastSuccess from "../../Toasts/ToastSuccess";
import ToastError from "../../Toasts/ToastError";
import Plus from "./Icons/Add.svg";
import ToastInfo from "../../Toasts/ToastInfo";
import Minus from "./Icons/minus.svg";
import { ButtonDarkBlue } from "../../HouseStyle/Components/Buttons";
import { BorderedTextInput } from "../../HouseStyle/Components/Inputs";
import { BorderedDropDown } from "../../HouseStyle/Components/DropDowns";
import { CountertopsRounded, EmailOutlined, TrendingUpOutlined } from "@mui/icons-material";
import { overEvery, trim, update } from "lodash";
import Phonenumber from "../Components/Phonenumber";
import { AddressKinds } from "../../Enums/addressKinds";
import { getCountryName } from "../../../utils";

const AddCustomerModal = ({ show, close, createdCustomerCallback, reloadOnSubmit = true }) => {
  const [showCustomer, setShowCustomer] = useState(false);
  const [countryInfo, setCountryInfo] = useState({});
  const [selectedCountry, setSelectedCountry] = useState({});
  const [emails, setEmails] = useState([""]);
  const navigate = useNavigate();
  const [phoneNumbers, setPhoneNumbers] = useState([
    { country_phone_prefix: "31", phone_number: "" },
  ]);
  const [debounceTimer, setDebounceTimer] = useState();
  const [prefixId, setPrefixId] = useState();
  const [formData, setFormData] = useState({
    newsPaper: false,
    birthday: false,
  });
  const [errorFields, setErrorFields] = useState({
    first_name: false,
    last_name: false,
    emails: [false, false, false],
    phone_numbers: [false, false, false],
    birth_date: false,
    postal_code: false,
    house_number: false,
    addition: false,
    street_name: false,
    city: false,
    country: false,
  });
  const formRef = useRef(null);

  const normalizeLabel = (label) => {
    return label.trim().replace(/[\s\-]+/g, "");
  };

  const getValueInput = useCallback((value, label) => {
    const normalizedLabel = normalizeLabel(label);
    setFormData((prev) => ({ ...prev, [normalizedLabel]: value }));
  }, []);

  const fetchCountry = async () => {
    const [fetchCountries] = await Promise.all([
      middleware.get(`/countryCodes`),
    ])
    const sorted = fetchCountries.data.data.sort((a, b) => b.order_by - a.order_by);
    const insertIndex = sorted.findIndex((country) => country.order_by === 0);
    setCountryInfo(sorted);
    if (insertIndex !== -1) {
      const before = sorted.slice(0, insertIndex);
      const after = sorted.slice(insertIndex);

      const newOptions = [...before, { disabled: true }, ...after];
      setCountryInfo(newOptions);
    }
  };

  useEffect(() => {
    if (selectedCountry.country_code_2 == "NL") {
      const { PostalCode, HouseNumber } = formData; // Destructure the relevant fields from formData
      const postalCodeRegex = /^\s*[0-9]{4}\s*[A-Za-z]{2}\s*$/;

      // Clear the previous debounce timer if it exists
      if (debounceTimer) {
        clearTimeout(debounceTimer);
      }

      if (PostalCode) {
        // Set a new debounce timer
        const newDebounceTimer = setTimeout(() => {
          // Check if Postalcode matches the regex
          if (postalCodeRegex.test(PostalCode)) {
            const fetchAdress = async () => {
              if (formData.HouseNumber) {
                try {
                  const response = await fetch(
                    `https://gratispostcodeapi.nl/api/v1/lookup/${PostalCode}/${HouseNumber}`
                  );
                  const data = await response.json();

                  // If the API returns valid postal_code data, populate formData
                  if (data && data.postal_code) {
                    setFormData((prevData) => ({
                      ...prevData,
                      Street: data.street,
                      City: data.city,
                      Addition:
                        data.available_suffixes.length > 0
                          ? data.available_suffixes[0]
                          : "",
                    }));
                    setErrorFields((prev) => {
                      return {
                        ...prev,
                        street_name: false,
                        city: false,
                      }
                    });
                  } else {
                    ToastError("Geen adres gevonden voor deze postcode.");
                  }
                } catch (error) {
                  ToastError(
                    "Er is een fout opgetreden bij het ophalen de adress gegevens"
                  );
                }
              } else {
                ToastInfo(
                  "Voer het huisnummer in om automatisch de straat en stad in te vullen"
                );
              }
            };

            fetchAdress(); // Call the function to fetch the house number
          }
        }, 1000); // 2 seconds debounce

        setDebounceTimer(newDebounceTimer); // Set the new timer
      }

      return () => clearTimeout(debounceTimer); // Cleanup timer on unmount or when dependencies change
    }
  }, [formData.PostalCode, formData.HouseNumber]);

  useEffect(() => {
    try {
      fetchCountry();
    } catch (error) {
      console.warn(error);
    }
  }, [showCustomer]);

  const removeEmailField = async (id) => {
    const confirmDelete = window.confirm(
      "Weet je zeker dat je deze e-mail wilt verwijderen?"
    );
    if (confirmDelete) {
      // Update state after successful deletion

      setEmails(emails.filter((e, index) => index != id));
      setErrorFields((prev) => {
        let updatedError = [...prev.emails];
        updatedError[id] = false;
        return {
          ...prev,
          emails: updatedError
        }
      })
    }
  };
  const removePhoneNumberField = async (id) => {
    const confirmDelete = window.confirm(
      "Weet je zeker dat je dit telefoonnummer wilt verwijderen?"
    );
    if (confirmDelete) {
      // Update state after successful deletion
      setPhoneNumbers(phoneNumbers.filter((e, index) => index != id));
    }
  };

  const validateFormData = async (trimmedData) => {
    setFormData(trimmedData);
    const phoneRegex = /^\d+$/;
    let selectedCountryCode = "NL";
    if (selectedCountry.country_code_2 != undefined) {
      selectedCountryCode = selectedCountry.country_code_2;
    }
    let errors = [];
    let unfilled_fields = [];
    const postalCodeRegex = /^\s*[0-9]{4}\s*[A-Za-z]{2}\s*$/;

    // Work with local copies of data during validation
    let localEmails = emails.map(email => email.trim()).filter(email => email !== "");
    let localPhoneNumbers = [...phoneNumbers];

    // Update state with cleaned emails
    setEmails(localEmails);

    // Email validation
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    localEmails.forEach((email, index) => {
      if (!emailPattern.test(email)) {
        errors.push("Email formaat is ongeldig");
        setErrorFields((prev) => {
          const oldEmails = [...prev.emails];
          oldEmails[index] = true;
          return { ...prev, emails: oldEmails };
        });
      }
    });

    // Phone number validation and cleaning
    if (localPhoneNumbers.length > 0) {
      // Clean phone numbers (remove leading zeros) in local array
      for (let index = localPhoneNumbers.length - 1; index >= 0; index--) {
        if (localPhoneNumbers[index].phone_number === "") {
          // Remove empty phone numbers
          localPhoneNumbers.splice(index, 1);
          continue;
        }
        
        // Remove leading zero if present
        if (localPhoneNumbers[index].phone_number.startsWith('0')) {
          localPhoneNumbers[index] = {
            ...localPhoneNumbers[index],
            phone_number: localPhoneNumbers[index].phone_number.slice(1)
          };
        }
      }

      // Update state with cleaned phone numbers
      setPhoneNumbers(localPhoneNumbers);

      // Validate cleaned phone numbers
      localPhoneNumbers.forEach((phone, index) => {
        if (!phoneRegex.test(phone.phone_number)) {
          errors.push("Telefoonnummer formaat is ongeldig");
          setErrorFields((prev) => {
            let updatedPhone = [...prev.phone_numbers];
            updatedPhone[index] = true;
            return {
              ...prev,
              phone_numbers: updatedPhone
            };
          });
        }
      });
    }

    // Postal code validation
    if (trimmedData.PostalCode && postalCodeRegex && !postalCodeRegex.test(trimmedData.PostalCode)) {
      errors.push("Postcode formaat is ongeldig");
      setErrorFields((prev) => {
        return {
          ...prev,
          postal_code: true
        };
      });
    }

    const errorPush = (field, userText) => {
      unfilled_fields.push(userText);
      setErrorFields((prev) => {
        return {
          ...prev,
          [field]: true
        };
      });
    };

    // Required field validation
    if (selectedCountry?.country_code_id == undefined) errorPush("country", "land");
    if (!trimmedData.FirstName) errorPush("first_name", "voornaam");
    if (!trimmedData.LastName) errorPush("last_name", "achternaam");
    if (!trimmedData.PostalCode) errorPush("postal_code", "postcode");
    if (!trimmedData.HouseNumber) errorPush("house_number", "huisnummer");
    if (!trimmedData.Street) errorPush("street_name", "straat");
    if (!trimmedData.City) errorPush("city", "stad");
    
    if (unfilled_fields.length > 0) {
      errors.push("De volgende velden zijn verplicht: " + unfilled_fields.join(", "));
    }
    
    // Return both errors and cleaned data
    return {
      errors,
      cleanedEmails: localEmails,
      cleanedPhoneNumbers: localPhoneNumbers
    };
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setErrorFields({
      first_name: false,
      last_name: false,
      emails: [false, false, false],
      phone_numbers: [false, false, false],
      postal_code: false,
      house_number: false,
      addition: false,
      street_name: false,
      city: false,
      country: false
    });

    const trimmedData = Object.fromEntries(
      Object.entries(formData).map(([key, value]) => [key, typeof value === 'string' ? value.trim() : value])
    );

    const validationResult = await validateFormData(trimmedData);
    
    if (validationResult.errors.length > 0) {
      for (let i = 0; i < validationResult.errors.length; i++) {
        ToastError(validationResult.errors[i]);
      }
      return;
    }

    // Use the cleaned data from validation instead of state
    storeCustomer(validationResult.cleanedEmails, validationResult.cleanedPhoneNumbers);
  };

  const storeCustomer = async (userEmails, userPhone) => {
    let consumerCreated = false;
    let consumerId = null;

    try {
      const response = await middleware.post("/addConsumers", {
        first_name: formData.FirstName,
        last_name: formData.LastName,
        emails: userEmails, // Now using the cleaned data passed as parameter
        phone_numbers: userPhone, // Now using the cleaned data passed as parameter
        city: formData.City,
        streetname: formData.Street,
        country_code_id: selectedCountry.country_code_id,
        birthday: formData.BirthDate,
        housenumber: formData.HouseNumber,
        addition: formData.Addition === "" ? null : formData.Addition,
        postalcode: formData.PostalCode,
        newsletter: formData.newsPaper === false ? 0 : 1,
        birthday_promotion: formData.birthday === false ? 0 : 1,
        address_kind: AddressKinds.DELIVERY_AND_INVOICE_ADDRESS,
        status: 1,
      });

      consumerCreated = true;
      consumerId = response.data.data.id;

      ToastSuccess("Consument is aangemaakt");
      if (reloadOnSubmit) {
        navigate("./bewerken/" + response.data.data.internal_id);
      } else {
        if (createdCustomerCallback) createdCustomerCallback(response.data.data);
        closeCustomerModal();
      }
    } catch (err) {
    console.error(err)
    ToastError('Iets ging fout tijdens het aanmaken van de klant');
    }
  };
  useEffect(() => {
    if (show) {
      setShowCustomer(true);
    }
  }, [show]);

  const handleCheckboxChange = (e, field) => {
    setFormData({
      ...formData,
      [field]: e.target.checked,
    });
  };

  const clearFormData = () => {
    setFormData({});
    setPhoneNumbers([{ country_phone_prefix: "31", phone_number: "" }]);
    setEmails([""]);
    setErrorFields({
      first_name: false,
      last_name: false,
      emails: [false, false, false],
      phone_numbers: [false, false, false],
      postal_code: false,
      house_number: false,
      addition: false,
      street_name: false,
      city: false,
      country: false,
    });
  };

  const closeCustomerModal = () => {
    setShowCustomer(false);
    close(true);
    clearFormData();
  };

  const handleFormSubmit = (e) => {
    if (formRef.current) {
      formRef.current.dispatchEvent(
        new Event("submit", { cancelable: true, bubbles: true })
      );
    }
  };

  const addEmailField = () => {
    if (emails.length < 3) {
      setEmails([...emails, ""]);
    } else {
      ToastError("Je kunt maximaal 3 e-mailadressen toevoegen");
    }
  };

  const setPhoneCode = (index, value) => {
    const newPhoneNumbers = [...phoneNumbers];
    newPhoneNumbers[index].country_phone_prefix = value;
    setPhoneNumbers(newPhoneNumbers);
  };
  const addPhoneNumberField = () => {
    if (phoneNumbers.length < 3) {
      const lastPhoneNumber = phoneNumbers[phoneNumbers.length - 1];
      const defaultPrefix = lastPhoneNumber?.country_phone_prefix || "31";
      setPhoneNumbers([...phoneNumbers, { country_phone_prefix: defaultPrefix, phone_number: "" }]);
    } else {
      ToastError("Je kunt maximaal 3 telefoonnummers toevoegen");
    }
  };
  // De functies hier zijn niet meer nodig sinds de housestyle
  // is toegevoegd maar bewaar ze hier alsnog voor de zekerheid
  //
  // const handleEmailChange = (index, value) => {
  //   const newEmails = [...emails];
  //   newEmails[index] = value;
  //   setEmails(newEmails);
  // };
  // const handlePhoneNumberChange = (index, value) => {
  //   const newPhoneNumbers = [...phoneNumbers];
  //   newPhoneNumbers[index].phone_number = value;
  //   setPhoneNumbers(newPhoneNumbers);
  // };
  return (
    <Modal
      id="modalBlueprint"
      show={showCustomer}
      onHide={() => closeCustomerModal()}
      size="xl"
      centered
    >
      <Modal.Header className="modalTop d-flex justify-content-between align-items-center">
        <div className="d-flex flex-row gap-4 flex-wrap align-items-center">
          <h4 className="fw-semibold text-nowrap">Consument aanmaken</h4>
          <BorderedDropDown
            placeholder="Kies een land"
            selectedValue={selectedCountry.country_code_id || ''}
            error={errorFields.country}
            setSelectedValue={(value) => {
              setSelectedCountry(countryInfo.find(country => country.country_code_id === value));
              setErrorFields((prev) => {
                return {
                  ...prev,
                  country: false,
                }
              });
            }
            }
            size="m"
            options={
              countryInfo?.length > 0
                ? countryInfo.map((country) => {
                    return {
                      key: country.order_by,
                      title: getCountryName(country.country_code_2),
                      value: country.country_code_id,
                      disabled: country.disabled
                    };
                  })
                : []
            }
          />
        </div>
        <button
          variant="transparent"
          className="btn"
          onClick={() => closeCustomerModal()}
        >
          <FontAwesomeIcon icon={faXmark} className="closeModal text-dark" />
        </button>
      </Modal.Header>
      <Modal.Body className="modalCenter">
        <div className="contendModal w-100">
          <form className="col-12" ref={formRef} onSubmit={handleSubmit}>
            <div className="col-12 d-flex flex-row gap-4 align-content-end mb-3">
              <BorderedTextInput
                type={"text"}
                label={"Voornaam"}
                error={errorFields.first_name}
                inputValue={formData.FirstName}
                setInputValue={(value) => {
                  getValueInput(value, "FirstName");
                  setErrorFields((prev) => {
                    return {
                      ...prev,
                      first_name: false
                    }
                  });
                }
                }
                size="l"
              />
              <BorderedTextInput
                label={"Achternaam"}
                inputValue={formData.LastName}
                error={errorFields.last_name}
                setInputValue={(value) => {
                  getValueInput(value, "LastName");
                  setErrorFields((prev) => {
                    return {
                      ...prev,
                      last_name: false
                    }
                  });
                }
                }
                size="l"
              />
            </div>
            <div className="col-12 d-flex flex-row gap-4 align-content-end my-3">
              <div className="d-flex flex-column gap-2 col-6 pe-3">
                <div className="d-flex justify-content-between">
                  <label className="mb-2">Emails</label>
                  <img
                    className="me-3 addIconSizeModals"
                    src={Plus}
                    onClick={addEmailField}
                    alt="Add"
                    style={{ cursor: "pointer", width: "3%" }}
                  />
                </div>
                {emails.map((email, index) => (
                  <div key={index} className="d-flex">
                    <BorderedTextInput
                      size={"l"}
                      inputValue={email}
                      error={errorFields.emails[index]}
                      setInputValue={(newEmail) => {
                        if (newEmail.includes(' ')) return;
                        setEmails((prevEmails) => {
                          const updatedEmails = [...prevEmails];
                          updatedEmails[index] = newEmail;
                          return updatedEmails;
                        });
                        setErrorFields((prev) => {
                          const updatedError = [...prev.emails];
                          updatedError[index] = false;
                          return {
                            ...prev,
                            emails: updatedError
                          }
                        })
                      }
                      }
                    />
                    <img
                      className="ms-2 removeIconSizeModals"
                      src={Minus}
                      onClick={() => removeEmailField(index)}
                      alt="Remove"
                      style={{ cursor: "pointer", width: "3%" }}
                    />
                  </div>
                ))}
              </div>
              <div className="d-flex flex-column gap-2 col-6 pe-3">
                <div className="d-flex justify-content-between">
                  <label className="mb-2">Telefoonnummers</label>
                  <img
                    className="me-3 addIconSizeModals"
                    src={Plus}
                    onClick={addPhoneNumberField}
                    alt="Add"
                    style={{ cursor: "pointer", width: "3%" }}
                  />
                </div>
                {phoneNumbers.map((phoneNumber, index) => (
                  <Phonenumber
                    key={index}
                    index={index}
                    phonenumber={phoneNumber}
                    setPhoneCode={(value) => setPhoneCode(index, value)}
                    handlePhoneNumberChange={(newNum) => {
                      setPhoneNumbers((prevNums) => {
                        const updatedNums = [...prevNums];
                        updatedNums[index].phone_number = newNum;
                        return updatedNums;
                      });
                      setErrorFields((prev) => {
                        let updatedError = [...prev.phone_numbers];
                        updatedError[index] = false;
                        return {
                          ...prev,
                          phone_numbers: updatedError
                        }
                      });
                    }}
                    removePhoneNumberField={() => removePhoneNumberField(index)}
                    removable={true}
                  />
                ))}
              </div>
            </div>
            <div className="col-12 d-flex flex-row align-content-end my-3">
              <InputComponent
                type={"date"}
                onValueChange={getValueInput}
                parentCol={6}
                labelName={"Geboortedatum"}
                labelValue={"BirthDate"}
                classnamesInput={"col-12 widthInputComponents px-3"}
              />

              {/* <div className="col-6 d-flex justify-content-start flex-wrap"> */}
                {/*<div className="col-4 d-flex flex-column fitContent">*/}
                {/*  <label className="mb-2 ms-4 fw-medium">Nieuwsbrief</label>*/}
                {/*  <label className="switchNewCustomer ms-4">*/}
                {/*    <input*/}
                {/*      type="checkbox"*/}
                {/*      checked={formData.newsPaper}*/}
                {/*      onChange={(e) => handleCheckboxChange(e, "newsPaper")}*/}
                {/*    />*/}
                {/*    <span className="sliderNewCustomer round"></span>*/}
                {/*  </label>*/}
                {/*</div>*/}
                {/* <div className="col-4 d-flex flex-column fitContent">
                  <label className="mb-2 ms-4 fw-medium">Verjaardagactie</label>
                  <label className="switchNewCustomer ms-4">
                    <input
                      type="checkbox"
                      checked={formData.birthday}
                      onChange={(e) => handleCheckboxChange(e, "birthday")}
                    />
                    <span className="sliderNewCustomer round"></span>
                  </label>
                </div> */}
              {/* </div> */}
            </div>
            <div className="col-12 d-flex flex-row gap-4 justify-content-between my-3">
              {
                // Disabled property bestaat nog niet voor <BorderedTextInput />, maar de expression heb ik er al in gezet
              }
              <BorderedTextInput
                label={"Postcode"}
                size={"m"}
                error={errorFields.postal_code}
                disabled={!selectedCountry.country_code_2}
                inputValue={formData.PostalCode}
                setInputValue={(value) => {
                  getValueInput(value, "PostalCode");
                  setErrorFields((prev) => {
                    return {
                      ...prev,
                      postal_code: false
                    }
                  });
                }
                }
              />
              <div className="col-6 d-flex justify-content-end">
                <div className="col-12 d-flex widthInputComponents flex-row gap-1 justify-content-end flex-wrap">
                  <BorderedTextInput
                    label={"Huisnummer"}
                    size={"l"}
                    error={errorFields.house_number}
                    disabled={!selectedCountry.country_code_2}
                    inputValue={formData.HouseNumber}
                    setInputValue={(value) => {
                      getValueInput(value, "HouseNumber");
                      setErrorFields((prev) => {
                        return {
                          ...prev,
                          house_number: false
                        }
                      });
                    }
                    }
                  />
                  <BorderedTextInput
                    label={"Toevoeging"}
                    size={"l"}
                    error={errorFields.addition}
                    disabled={!selectedCountry.country_code_2}
                    inputValue={formData.Addition}
                    setInputValue={(value) => getValueInput(value, "Addition")}
                  />
                </div>
              </div>
            </div>
            <div className="col-12 d-flex flex-row gap-4 align-content-end my-3">
              <BorderedTextInput
                type={"text"}
                onValueChange={getValueInput}
                error={errorFields.street_name}
                size={"l"}
                label={
                  <>
                    Straat
                    {selectedCountry.country_code_2 === "NL" &&
                      formData.Street && (
                        <FontAwesomeIcon
                          style={{ marginLeft: "5px", cursor: "pointer" }}
                          onClick={() =>
                            setFormData((prev) => ({
                              ...prev,
                              StreetNameEditable: !prev.StreetNameEditable,
                            }))
                          }
                          icon={faPencilAlt}
                        />
                      )}
                  </>
                }
                inputValue={formData.Street}
                setInputValue={(value) => {
                  getValueInput(value, "Street");
                  setErrorFields((prev) => {
                    return {
                      ...prev,
                      street_name: false
                    }
                  });
                }
                }
                disabled={
                  !selectedCountry.country_code_2 ||
                  (!formData.StreetNameEditable &&
                    selectedCountry.country_code_2 === "NL")
                }
                defaultValue={formData.Street}
              />
              <BorderedTextInput
                size={"l"}
                error={errorFields.city}
                labelName={
                  <>
                    Stad
                    {selectedCountry.country_code_2 === "NL" && formData.City && (
                      <FontAwesomeIcon
                        style={{ marginLeft: "5px", cursor: "pointer" }}
                        onClick={() =>
                          setFormData((prev) => ({
                            ...prev,
                            CityEditable: !prev.CityEditable,
                          }))
                        }
                        icon={faPencilAlt}
                      />
                    )}
                  </>
                }
                label={"City"}
                inputValue={formData.City}
                setInputValue={(value) => {
                  getValueInput(value, "City");
                  setErrorFields((prev) => {
                    return {
                      ...prev,
                      city: false
                    }
                  });
                }
                }
                disabled={
                  !selectedCountry.country_code_2 ||
                  (!formData.CityEditable &&
                    selectedCountry.country_code_2 === "NL")
                }
                defaultValue={formData.City}
              />
            </div>
          </form>
        </div>
      </Modal.Body>
      <Modal.Footer className="modalBottom">
          <ButtonDarkBlue
            onClickFunction={handleFormSubmit}
            text={"Consument aanmaken"}
          />
      </Modal.Footer>
    </Modal>
  );
};

export default AddCustomerModal;
